export class userInfo {
    static getInfo() {
        const myData = [
            {
                // getting user info
                userInfo : [
                    {
                        name: 'Manthan Gajjar',
                        position: 'Full stack developer  🖥',
                        experience: '3+ years',
                        img_path: '../../../assets/img/img.jpg'
                    }
                ],
                // something about user
                about_user: [
                    //  about ME
                    {
                        sec_img: '../../../assets/img/imgg.jpg',
                        who_am_i: `Have 2.4+ experience in Full stack development with good communication skills.
                        Having Positive approach towards work and logical & practical approach to problem solving.
                        `,
                        who_am_i_paragraph: `Apart from this, Manthan Gajjar is a part-time photographer,
                                    and the founder of
                                    <a style = "color: black !important" target = "_blank" href="https://photographywith.com">www.photographywith.com</a> , He has a very deep interest in photography,
                                    His smart work, Thinking ability, passion and dedication make him stand apart from other humans.
                                    
                                    <div>
                                    <br/> 
                                    Current Status <hr/>
                                    <p>
                                      <b> Learning React 🤓🤓🤓  </b>  
                                    </p>
                                    </div>
                                    
                                    
                                    `
                    },
                    //  add multiple skills here img must be 512 x 512 px
                    {
                        skill_: 'Node js',
                        knowledge: '85',
                        knowledge_percentage: '85%',
                        img_path: '../../../assets/lang_img/nodejs-512.png'
                    },
                    {
                        skill_: 'Angular 6+',
                        knowledge: '90',
                        knowledge_percentage: '90%',
                        img_path: '../../../assets/lang_img/angular.png'
                    },
                    {
                        skill_: 'Mongo DB',
                        knowledge: '80',
                        knowledge_percentage: '80%',
                        img_path: '../../../assets/lang_img/mongo.png'
                    },
                    {
                        skill_: 'Sails.js',
                        knowledge: '80',
                        knowledge_percentage: '80%',
                        img_path: '../../../assets/lang_img/sailsjs.jpg'
                    },
                    {
                        skill_: 'Ionic',
                        knowledge: '85',
                        knowledge_percentage: '85%',
                        img_path: '../../../assets/lang_img/ionic.jpg'
                    }
                ],
                //  what user have done
                user_projects: [
                    {
                        project: 'SEVEN',
                        description: `Seven is a matchmaking mobile application built-in with react native
                         and node js as backend, which will allow the user to get a 100% match in real-time.`,
                        img_path: '',
                        live_url: '',
                        technology: 'Node TS, Firebase, AWS, Socket IO'
                    },
                    {
                        project: 'TradeLoop',
                        description: `TradeLoop is Combination of Seller PWA, Buyer ( mobile app ) and admin Admin Panel ),
                         where seller can sell & modify his/her products via admin panel and the buyer can buy a product through a mobile application`,
                        img_path: '',
                        live_url: 'https://play.google.com/store/apps/details?id=com.tradeloop.tradeloop&hl=en_IN&gl=US',
                        technology: 'Node TS, PostgreSQL, Angular 9'
                    },
                    {
                        project: 'PromoStar',
                        description: `It's a game based application, 
                        where users can join contest and win real money plus admin panel to manage contest and financial stuffs.`,
                        img_path: '',
                        live_url: 'https://apps.apple.com/us/app/promostar-meet-celebs-win-%24/id1521440593',
                        technology: ' Node TS, MongoDB, Angular 8, Pubnub'
                    },
                    {
                        project: 'GTU Notes',
                        description: `GTU Notes is totally built with IONIC V3 (recently moved to Ionic V5), this android application
                        helps GTU students to find some cool notes and
                        papers on the go for BE students ( More than 6 Branches and 100+ Subject are currently available),
                        also, students can share it with their friends easily with this single & less than 7MB application
                        `,
                        img_path: '',
                        live_url: 'https://play.google.com/store/apps/details?id=gtu.quick.notes',
                        technology: 'Ionic 5, Firebase'
                    },
                    {
                        project: 'Yousic',
                        description: `This is the currant ongoing project which I'm working on, basically this application is kind of Facebook for music Lovers.
                         Where user can join, follow, like, share, their friends and post musics from Itunes & Spotify.
                         User Can also chat with other users ( one to one and Group Chat ), and share some good musics, pictures etc... with their friends. also there is one Admin Panel to manage all the posts and user stats.
                        `,
                        img_path: '',
                        live_url: '',
                        technology: 'Node TS, Angular, MongoDB, Socket IO'
                    }
                ],
                // user information social app links
                user_information: [
                    {
                        name: 'Instagram',
                        url: 'https://www.instagram.com/pewdoc_/',
                        img_path: '../../../assets/user_info/instagram.svg'
                    },
                    {
                        name: 'Linkedin',
                        url: 'https://www.linkedin.com/in/manthan-gajjar-395268168/',
                        img_path: '../../../assets/user_info/linkedin.svg'
                    },
                    {
                        name: 'Skype',
                        url: 'https://join.skype.com/invite/dnNfnrp7s4MF',
                        img_path: '../../../assets/user_info/skype.svg'
                    },
                    {
                        email: 'Manthangajjar08@gmail.com',
                        href_email: 'mailto:Manthangajjar08@gmail.com',
                        img_path: '../../../assets/user_info/gmail.svg'
                    }
                ]
            }
        ]
        return myData;
    }
}
